import React from 'react';
import ReplyView from './ReplyView';
import TaskMessaging from "../../../ws/TaskMessaging";
import { LoadingView, Role, TaskGetAppInfo } from '@cuatroochenta/co-admin-react-library';
import { Conversation, Message } from '../../../model/domain/messaging';

interface ApiResponseMessage {
    code: string;
    data: {
        total_pages: number;
        total_count: number;
        current_page: number;
        limit: number;
        messages: Message[];
    };
}

interface ReplyContainerProps {
    conversation: Conversation;
    onClose: () => void;
}

interface State {
    conversation: Conversation;
    currentPage: number;
    totalPages: number;
    fetchingMore: boolean;
    messagesCurrentPage: number;
    messagesTotalPages: number;
    messagesFetchingMore: boolean;
    filters: {

    };
    loading: boolean;
    error: Error | null;
}

class ReplyContainer extends React.Component<ReplyContainerProps, State> {

    state: State = {
        conversation: {
            ...this.props.conversation,
            messages: this.props.conversation.messages || [], 
        },
        currentPage: 1,
        totalPages: 1,
        fetchingMore: false,
        filters: {

        },
        loading: true,
        error: null,
        messagesCurrentPage: 1,
        messagesTotalPages: 1,
        messagesFetchingMore: false
    };

    componentDidMount() {
        this.getMessages(this.props.conversation);
        window.addEventListener('scroll', this.handleScroll, true);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    handleScroll = () => {
        const { conversation, currentPage, totalPages, fetchingMore, loading, filters } = this.state;

        if (loading || fetchingMore) return;

        if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
            if (currentPage < totalPages) {
                this.setState({ fetchingMore: true });
                this.getMessages(conversation, currentPage + 1, filters);
            }
        }
    };

    public getMessages(conversation: Conversation, page: number = 1, filters: any = this.state.filters) {
        this.setState({ loading: true });

        const url = `${conversation.id}/message?page=${page}&role_id=${Role.ADMIN}`;

        new TaskMessaging().getMessages(url)
    .catch(
        (error: Error) => {
            console.error('Error al obtener los mensajes de la conversación:', error);
            this.setState({ error, loading: false, messagesFetchingMore: false });
        }
    )
    .then(
        (data: ApiResponseMessage) => {
            if (data.code && data.data) {
                // Refresh sidebar notification count
                if (conversation.unreadMessageCount > 0 && page === 1) {
                    new TaskGetAppInfo().execute();
                }

                const newMessages = data.data.messages.map(message => ({
                    ...message
                }));

                this.setState((prevState) => {
                    const allMessages = [
                        ...newMessages,
                        ...prevState.conversation.messages.filter(
                            (msg) => !newMessages.some((newMsg) => newMsg.id === msg.id)
                        ),
                    ].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

                    return {
                        conversation: {
                            ...prevState.conversation,
                            messages: allMessages,
                        },
                        messagesTotalPages: data.data.total_pages,
                        messagesCurrentPage: data.data.current_page,
                        loading: false,
                        messagesFetchingMore: false,
                    };
                });
            } else {
                this.setState({ error: new Error('No se encontraron conversaciones'), loading: false });
            }
        }
    );
        
    }

    handleLoadMoreMessages = () => {
        const { conversation, messagesCurrentPage, messagesTotalPages, messagesFetchingMore } = this.state;
    
        if (messagesFetchingMore || messagesCurrentPage >= messagesTotalPages) return;
    
        this.setState({ messagesFetchingMore: true });
        this.getMessages(conversation, messagesCurrentPage + 1);
    };

    render() {
        const { onClose } = this.props;
        const { conversation, loading, error, messagesFetchingMore } = this.state;
    
        if (loading && (!conversation.messages || conversation.messages.length === 0)) {
            return <LoadingView loading={loading} />;
        }        
    
        if (error) {
            return <div>Error: {error.message}</div>;
        }

        return (
            <div>
                <ReplyView 
                conversation={conversation} onClose={onClose}
                onSendMessage={() => this.getMessages(conversation)}
                onLoadMoreMessages={this.handleLoadMoreMessages}
                loading={messagesFetchingMore} />
            </div>
        );
    }
    
}

export default ReplyContainer;
